/**
 * Shared date formatting helpers for UI display.
 */

export const formatIsoDateToDisplay = (date?: string | null, options?: { emptyText?: string }) => {
  const emptyText = options?.emptyText ?? '-';
  if (!date) return emptyText;

  const raw = String(date).slice(0, 10); // supports YYYY-MM-DD or ISO strings
  const [year, month, day] = raw.split('-');

  if (!year || !month || !day) return date;
  // MM/DD/YYYY
  return `${month}/${day}/${year}`;
};

